import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { DialogShellComponent } from '@custom-components/overlay/dialog-shell/dialog-shell.component';

export interface ConfirmCloseStatusDialogData {
  statusName: string;
  resetsDeviceLog?: boolean;
}

@Component({
  selector: 'confirm-close-status-dialog',
  imports: [MatIconModule, MatButtonModule, MatDialogModule, TranslateModule, DialogShellComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './confirm-close-status-dialog.component.html',
})
export class ConfirmCloseStatusDialogComponent {
  readonly dialogRef = inject(MatDialogRef<ConfirmCloseStatusDialogComponent>);
  public data = inject<ConfirmCloseStatusDialogData>(MAT_DIALOG_DATA);

  onConfirm(): void {
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
